import React, { useEffect, useState } from "react";
import { GeoJson } from "pigeon-maps";
import { sanitizeGeoJsonForMercator } from "../../utils/sanitize-geojson-mercator";

type Props = React.ComponentProps<typeof GeoJson> & {
  link: string;
};

/**
 * Like pigeon-maps GeoJsonLoader, but clamps latitudes so polar vertices
 * never produce Infinity in SVG path `d` (Mercator).
 */
const SafeGeoJsonLoader: React.FC<Props> = ({ link, ...geoProps }) => {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(link)
      .then((r) => r.json())
      .then((json) => {
        if (!cancelled) setData(sanitizeGeoJsonForMercator(json));
      })
      .catch(() => {
        /* ignore */
      });
    return () => {
      cancelled = true;
    };
  }, [link]);

  if (!data) return null;
  return <GeoJson {...geoProps} data={data} />;
};

export default SafeGeoJsonLoader;
